import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

const NotFound = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4 text-center">
      
      <AlertTriangle className="w-16 h-16 text-red-500 mb-4" />

      <h1 className="text-6xl font-bold text-gray-800">404</h1>

      <h2 className="text-2xl font-semibold mt-2 text-gray-700">
        Page Not Found
      </h2>

      <p className="text-gray-500 mt-3 max-w-md">
        Sorry, the page you’re looking for doesn’t exist or has been moved.
      </p>

      <Link
        to="/"
        className="
          mt-6 inline-block
          px-6 py-3
          bg-blue-600 text-white font-semibold
          rounded-lg
          hover:bg-blue-700
          transition
        "
      >
        Go Back Home
      </Link>

    </div>
  );
};

export default NotFound;
